import { Div, Link } from "@tblabs/truffle";
import { InfoBox } from "../Components/InfoBox";
import { LoaderSpinner } from "./LoaderSpinner";
import { PrimaryButton } from "../Components/PrimaryButton";


export class Page extends Div
{
    public body: Div;
    public footer: Div;
    private loader = new LoaderSpinner("Ładowanie strony...");

    constructor(private pageTitle: string)
    {
        super();
        this.Class("page");
        this.PaddingBottom(48).PaddingTop(32)

        document.title = this.pageTitle;

        this.body = new Div("").Style(`padding: 16px; padding-top: 0; max-width: 800px; margin: 0 auto;`);
        this.footer = new Div("footer").Append(
            "🏠 ", new Link("Home").OnClick(() => window.location.hash = ""),
            " 🔒 ", new Link("Login").OnClick(() => window.location.hash = "login"),
        )

        this.Append(
            new Div("content")
                .Append(
                    new Div("").Append(
                        this.body
                    )),
            this.footer,
        );
    }

    public async Content(content: () => Promise<void>): Promise<void>
    {
        try
        {
            this.Append(
                this.loader,
            )

            await content();
        }
        catch (ex: any)
        {
            console.error(ex);

            this.body.Append(
                new InfoBox("Błąd", ex.message),
                new PrimaryButton("Logowanie").OnClick(() => window.location.hash = "login"),
                new PrimaryButton("Strona główna").OnClick(() => window.location.hash = "").MarginLeft(12),
            );
        }
        finally
        {
            this.loader.RemoveSelf();
        }
    }
}
